import { Button, Modal } from "react-bootstrap";
import SignInContent from "components/sign-in/form";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { close, getLoginModalsState, LoginModalSlice, } from "state/slices/login-modals-slice";
import styles from "./styles.module.scss";
import SignUpContent from "components/sign-up/form";
import BlockyMediumText from "components/custom-texts/blocky-medium-text";
import { useEffect, useState } from "react";
import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import Logo from "icons/SPARKET-LOGO-NOTAG-onwhite-wHITE-R.png";
import { secondaryColor, sparketBlack } from "utils/constants";
import { getGroupState } from "state/slices/group-slice";

const getContent = (state: LoginModalSlice) => {
  if (state.signUpOpen) {
    return SignUpContent;
  }

  if (state.signInOpen) {
    return SignInContent;
  }

  return false;
};

const LoginModal = () => {
  const state = useAppSelector(getLoginModalsState);
  const show = state.signInOpen || state.signUpOpen;
  const dispatch = useAppDispatch();
  const Content = getContent(state);
  const [allowClickOutside, setAllowClickOutside] = useState(true);
  const [showConfirmationForm, setShowConfirmationForm] = useState(false);

  const groupLogoUrl = useAppSelector(getGroupState).settings.logo_url 

  useEffect(() => {
    setShowConfirmationForm(false);
  }, [show]);

  return (
    <Modal
      onHide={() => {
        if (allowClickOutside) {
          dispatch(close());
        }
      }}
      show={show}
      contentClassName={styles.modalContent}
    >
      <div className={styles.column}>
        <div
          className={styles.column}
          style={{
            backgroundSize: "contain",
            alignItems: "center",
          }}
        >
          <BlockyMediumText style={{ color: secondaryColor }}>
            You must be logged in to make a pick
          </BlockyMediumText>
          {!allowClickOutside && (
            <div
              style={{
                marginTop: 17,
                width: "100%",
                marginLeft: 117,
                marginBottom: -20,
                zIndex: 100000,
              }}
            >
              <Button
                style={{
                  backgroundColor: secondaryColor,
                  borderColor: secondaryColor,
                  color: sparketBlack,
                  borderRadius: 5,
                  marginBottom: 5,
                }}
                onClick={() => {
                  setShowConfirmationForm(false);
                }}
              >
                <BlockyHeavyText customStyles={{ fontSize: 14 }}>
                  &lt; Back
                </BlockyHeavyText>
              </Button>
            </div>
          )}
          <img
            alt=""
            src={groupLogoUrl || Logo}
            style={{
              width: "100%",
              height: "100%",
              padding: 30,
              objectFit: "contain",
              maxHeight: 145 
            }}
          />
          {Content && (
            <Content
              showConfirmationForm={showConfirmationForm}
              setShowConfirmationForm={setShowConfirmationForm}
              setAllowClickOutside={setAllowClickOutside}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default LoginModal;
